import React, { useContext, useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { NiKendoContext } from '../context/NiKendoContext';
import { RootState } from 'types/types';
import Loader from 'components/Common/Loader';
import MapComponent from './MapComponent';
import Popup from 'components/Common/Popup';
import PopupActions from 'components/Common/PopupActions';
import { setMapPopupState } from 'features/applicationState';
import { useDispatch } from 'react-redux';

export default function NiKendo() {
  const { niKendoModule } = useContext(NiKendoContext);
  const appLayoutRef = useRef<any>(null);
  const { viewId } = useParams();
  const params = useLocation();
  const { mapPopupState } = useSelector(
    (state: RootState) => state.applicationState
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const openView = async () => {
      if (niKendoModule?.application?.layout && appLayoutRef.current) {
        niKendoModule.application.layout
          .kendoLayout()
          .render(appLayoutRef.current);
        if (viewId) {
          const properties = Array<any>();
          const sp = new URLSearchParams(params.search);
          for (const [key, value] of sp) {
            properties.push({ Name: key, Value: value });
          }
          niKendoModule.application.layout.openView({
            value: viewId,
            properties,
          });
        } else {
          console.log('not opening since it is the current view %o %o', viewId);
        }
      }
    };

    openView();
  }, [niKendoModule?.application?.layout, appLayoutRef, params, viewId]);

  return (
    <>
      {niKendoModule && !niKendoModule.application && <Loader />}

      <div id="app" style={{ width: '100%', height: '100%' }}>
        <div id="appLayout" ref={appLayoutRef}></div>
      </div>
      <Popup width="1000px" height="800px" title="Map Coordinates" content={<MapComponent />} open={mapPopupState.isVisible} onClose={()=>null} 
       actions={
        <PopupActions
          actionsList={[{title:'Apply', className: 'k-button close-button', onClick: function(){
            if(!mapPopupState.geoJson)
              return;
            let geoJson =  mapPopupState.geoJson.geometry ?? mapPopupState.geoJson; //mapPopupState.geoJson.geometry will be filled if we edit and apply without doing any changes
            mapPopupState.getGeoJsonCallback(JSON.stringify(geoJson), mapPopupState.region);
            dispatch(setMapPopupState({isVisible: false, getGeoJsonCallback: ()=>null, geoJson:null, region:null }));
          }}, 
          {title:'Cancel', className: 'k-button cancel-button', onClick: function(){
            dispatch(setMapPopupState({isVisible: false, getGeoJsonCallback: ()=>null, geoJson:null, region:null }));
          }}]}
        />
      }
      ></Popup>
    </>
  );
}
